export function highlightMatch(
    text: string,
    search: string,
    highlightClassName?: string,
) {
    if (!search) return text;
    const regex = new RegExp(
        `(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
        'gi',
    );
    return text.split(regex).map((part, i) =>
        regex.test(part) ? (
            <mark key={i} className={highlightClassName}>
                {part}
            </mark>
        ) : (
            part
        ),
    );
}
